<template>
  <div class="help-center-header">
    <CofocusLogo style="transform: scale(1.08)" />
    <div class="help-center-title">Help Center</div>
  </div>
</template>

<script>
import CofocusLogo from "../../../../src/components/Nav/NavComponents/CofocusLogo.vue";

export default {
  name: "HelpCenterTitle",
  components: {
    CofocusLogo,
  },
};
</script>

<style scoped>
.help-center-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 32px;
  top: 32px;
}
.help-center-title {
  font-weight: 600;
  letter-spacing: -0.7px;
  font-size: 21px;
  margin-left: -5px;
}
</style>